import {getGrandfatheringData} from 'BOSTools/ducks/bosTools';
import {BOSToolsRouteConstants} from 'BOSTools/Routes';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import FileDownloadButton, {FileExtension} from 'Shared/components/FileDownloadButton';
import FileDownloadFab from 'Shared/components/FileDownloadFab';
import Column from 'Shared/components/PagedView/Column';
import PagedView from 'Shared/components/PagedView/PagedView';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import isMobile from 'Shared/utilities/isMobile';
import {useWidth} from 'Shared/utilities/UseWidth';

const GrandfatheringData = () => {
  const dispatch = useDispatch();
  const {grandfatheringData} = useSelector((state: ReducerState) => state.bostools);

  useBreadcrumbs('Grandfathering Data Report', BOSToolsRouteConstants.GRANDFATHERING_DATA);

  useEffect(() => {
    dispatch(getGrandfatheringData(undefined));
  }, []);

  const exportToCsvProps = {
    starticon: <i className="fa fa-2x fa-file-download" />,
    extension: FileExtension.CSV,
    downloadedFileName: 'GrandfatheringDataReport',
    relativeFileLocation: `/bostools/grandfatheringdata${addFilterParameters({
      exportToCsv: true,
    })}`,
    children: 'Export To CSV',
  };

  return (
    <>
      <PagedView
        pagedViewKey="grandfatheringData"
        loadMore={page => dispatch(getGrandfatheringData(page))}
        data={grandfatheringData}
        actions={
          isMobile({width: useWidth()}) ? (
            <FileDownloadFab variant="extended" color="primary" displayTooltip {...exportToCsvProps} />
          ) : (
            <FileDownloadButton variant="contained" color="primary" displayTooltip {...exportToCsvProps} />
          )
        }
      >
        {columnProps => (
          <>
            <Column {...columnProps} title="EIN" default>
              {report => report.employeeIdentificationNumber}
            </Column>
            <Column {...columnProps} title="Case Number" default>
              {report => report.caseNumbers}
            </Column>
            <Column {...columnProps} title="Channel" default>
              {report => report.channel}
            </Column>
            <Column {...columnProps} title="Product and Plans" default>
              {report => report.productAndPlans}
            </Column>
            <Column {...columnProps} title="Product Types" default>
              {report => report.productTypes}
            </Column>
            <Column {...columnProps} title="Is Missing" default>
              {report => report.isMissing}
            </Column>
          </>
        )}
      </PagedView>
    </>
  );
};

export default GrandfatheringData;
